import { useMemo } from 'react';
import { useWindowSize } from 'react-use';

type MediaQueryResult = {
  xs: boolean;
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
  xxl: boolean;
};

/**
 * 使用 media query 检测当前屏幕尺寸
 * @returns 各个断点的布尔值对象
 * @example
 * const { lg, xl } = useMediaQuery();
 * if (lg) {
 *   // 屏幕宽度 >= 1024px
 * }
 */
export function useMediaQuery(): MediaQueryResult {
  const { width } = useWindowSize();

  return useMemo(() => {
    return {
      xs: width >= 0,
      sm: width >= 640,
      md: width >= 768,
      lg: width >= 1024,
      xl: width >= 1280,
      xxl: width >= 1536,
    };
  }, [width]);
}
